import React from "react";

const Menu = () => {
  return (
    <div className="h-screen flex justify-center items-center bg-yellow-300">
      <h1 className="text-9xl uppercase font-black">egg menu</h1>
    </div>
  );
};

export default Menu;
